import { BASE_DARK_THEME_PALETTE } from '../constants/baseDarkThemePalette';
import { BASE_LIGHT_THEME_PALETTE } from '../constants/baseLightThemePalette';
import { generateThemePalette } from './generateThemePalette';
import { getThemeMetadata } from './getThemeMetadata';
import { type ThemeId } from '../schema/ThemeId';
import type { ThemePalette } from '../schema/MiniPalette';

const themePaletteMap = new Map<string, ThemePalette>();

export const getThemePalette = (themeId: ThemeId, isDarkTheme: boolean): ThemePalette => {
    const mapKey = `${themeId}_${isDarkTheme ? 'dark' : 'light'}`;
    if (!themePaletteMap.has(mapKey)) {
        // For default theme (Blue), we continue using already defined static theme palette for the sake of consistency
        if (themeId === 'Blue') {
            themePaletteMap.set(
                mapKey,
                isDarkTheme ? BASE_DARK_THEME_PALETTE : BASE_LIGHT_THEME_PALETTE
            );
        } else {
            const { color } = getThemeMetadata(themeId, isDarkTheme);
            themePaletteMap.set(mapKey, generateThemePalette(color, isDarkTheme));
        }
    }

    return themePaletteMap.get(mapKey);
};
